import Header from '@/components/feature/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <FaqSection />
        <CarouselSection />
        <CardsSection />
        <AboutSection />
        <MediaSection />
        <CommentsSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}